// extracted by mini-css-extract-plugin
var _1 = "ra-sticky-scroll-parent-fixed-bottom";
var _2 = "ra-sticky-scroll-parent";
var _3 = "ra-sticky-scroll-parent-fixed";
var _4 = "ra-sticky-scroll-parent-inner";
export { _1 as "stickyScrollParentBottomFixedCls", _2 as "stickyScrollParentCls", _3 as "stickyScrollParentFixedCls", _4 as "stickyScrollParentInnerCls" }
